<template>
  <div>
    <el-carousel height="49.37rem" autoplay>
      <el-carousel-item v-for="(image, index) in pageImageList" :key="index">
        <img class="page_dev_img" :src="require(`@/assets/${image}`)" :alt="'Image ' + (index + 1)" />
      </el-carousel-item>
    </el-carousel>
    <div>
      <div class="title_cs">跨境电商</div>
      <div class="page_sets">
        <div
          v-for="(advantage, index) in advantages"
          :key="index"
          :class="[advantage.isVisible ? 'advantage' : '']"
        >
          <div class="page_devs">
            <div class="page_title">{{ advantage.title }}</div>
            <button class="advantage-button" @click="toggleAdvantage(index)">
              <i v-if="advantage.isVisible" class="el-icon-arrow-up page_ico2"></i>
              <i v-if="!advantage.isVisible" class="el-icon-arrow-down page_ico2"></i>
            </button>
          </div>
          <div :class="['advantage-content', { visible: advantage.isVisible }]">
            <div class="page_advantage_d">
              <div class="page_set_de_e">
                <div class="page_set_text page_set_text2">{{ advantage.description }}</div>
                <!-- <div class="page_set_text">{{ advantage.text }}</div> -->
              </div>
              <div class="image_flex">
                <img class="page_advantage_img" src="../assets/pinpai1.png" />
                <img class="page_advantage_img" src="../assets/pinpai1.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="title_cs">仓储管理</div>
      <div class="page_sets">
        <div
          v-for="(advantage, index) in advantages2"
          :key="index"
          :class="[advantage.isVisible ? 'advantage' : '']"
        >
          <div class="page_devs">
            <div class="page_title">{{ advantage.title }}</div>
            <button class="advantage-button" @click="toggleAdvantage2(index)">
              <i v-if="advantage.isVisible" class="el-icon-arrow-up page_ico2"></i>
              <i v-if="!advantage.isVisible" class="el-icon-arrow-down page_ico2"></i>
            </button>
          </div>
          <div :class="['advantage-content', { visible: advantage.isVisible }]">
            <div class="page_advantage_d">
              <div class="page_set_de_e">
                <div class="page_set_text page_set_text2">{{ advantage.description }}</div>
                <!-- <div class="page_set_text">{{ advantage.text }}</div> -->
              </div>
              <div class="image_flex">
                <img class="page_advantage_img" src="../assets/pinpai1.png" />
                <img class="page_advantage_img" src="../assets/pinpai1.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="title_cs">供应链优化</div>
      <div class="page_sets">
        <div
          v-for="(advantage, index) in advantages3"
          :key="index"
          :class="[advantage.isVisible ? 'advantage' : '']"
        >
          <div class="page_devs">
            <div class="page_title">{{ advantage.title }}</div>
            <button class="advantage-button" @click="toggleAdvantage3(index)">
              <i v-if="advantage.isVisible" class="el-icon-arrow-up page_ico2"></i>
              <i v-if="!advantage.isVisible" class="el-icon-arrow-down page_ico2"></i>
            </button>
          </div>
          <div :class="['advantage-content', { visible: advantage.isVisible }]">
            <div class="page_advantage_d">
              <div class="page_set_de_e">
                <div class="page_set_text page_set_text2">{{ advantage.description }}</div>
                <!-- <div class="page_set_text">{{ advantage.text }}</div> -->
              </div>
              <div class="image_flex">
                <img class="page_advantage_img" src="../assets/pinpai1.png" />
                <img class="page_advantage_img" src="../assets/pinpai1.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageImageList: ["lunbo.png", "lunbo.png", "lunbo.png", "lunbo.png"],
      advantages: [
        {
          title: "优势一",
          description:
            "合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传",
          isVisible: false,
          text:
            "为世界前沿品牌和零售制造铸造商业化浪潮为备份为世界前沿品牌和零售制造铸造商业化浪潮为备份为世界前沿品牌和零售制造铸造商业化浪潮为备份"
        },
        {
          title: "优势二",
          description: "描述优势二的标题",
          isVisible: false,
          text: "描述优势二的具体内容"
        },
        {
          title: "优势三",
          description: "描述优势三的标题",
          isVisible: false,
          text: "描述优势三的具体内容"
        },
        {
          title: "优势四",
          description: "描述优势四的标题",
          isVisible: false,
          text: "描述优势四的具体内容"
        }
      ],
      advantages2: [
        {
          title: "优势一",
          description:
            "合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传",
          isVisible: false,
          text:
            "为世界前沿品牌和零售制造铸造商业化浪潮为备份为世界前沿品牌和零售制造铸造商业化浪潮为备份为世界前沿品牌和零售制造铸造商业化浪潮为备份"
        },
        {
          title: "优势二",
          description: "描述优势二的标题",
          isVisible: false,
          text: "描述优势二的具体内容"
        },
        {
          title: "优势三",
          description: "描述优势三的标题",
          isVisible: false,
          text: "描述优势三的具体内容"
        },
        {
          title: "优势四",
          description: "描述优势四的标题",
          isVisible: false,
          text: "描述优势四的具体内容"
        }
      ],
      advantages3: [
        {
          title: "优势一",
          description:
            "合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传/合作门店加入宣传",
          isVisible: false,
          text:
            "为世界前沿品牌和零售制造铸造商业化浪潮为备份为世界前沿品牌和零售制造铸造商业化浪潮为备份为世界前沿品牌和零售制造铸造商业化浪潮为备份"
        },
        {
          title: "优势二",
          description: "描述优势二的标题",
          isVisible: false,
          text: "描述优势二的具体内容"
        },
        {
          title: "优势三",
          description: "描述优势三的标题",
          isVisible: false,
          text: "描述优势三的具体内容"
        },
        {
          title: "优势四",
          description: "描述优势四的标题",
          isVisible: false,
          text: "描述优势四的具体内容"
        }
      ]
    };
  },
  methods: {
    toggleAdvantage(index) {
      this.$set(this.advantages, index, {
        ...this.advantages[index],
        isVisible: !this.advantages[index].isVisible
      });
    },
   

    toggleAdvantage2(index) {
      this.$set(this.advantages2, index, {
        ...this.advantages2[index],
        isVisible: !this.advantages2[index].isVisible
      });
    },
   
    toggleAdvantage3(index) {
      this.$set(this.advantages3, index, {
        ...this.advantages3[index],
        isVisible: !this.advantages3[index].isVisible
      });
    },
}
};
</script>

<style scoped>
.page_dev_img {
  width: 100%;
  height: 49.37rem;
  object-fit: cover;
}

.title_cs {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 3.125rem;
  color: #131316;
  line-height: 3.125rem;
  margin-top: 6.875rem;
  margin-bottom: 5rem;
}

/* 我们的优势 */
.page_sets {
  padding: 0 5rem;
}

.advantage {
  /* margin-bottom: 20px; */
  padding-bottom: 3.25rem;
}

.advantage-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.advantage-content.visible {
  max-height: 50rem;
  /* 可以根据需要调整这个值 */
}

button {
  margin-top: 0.3rem;
  cursor: pointer;
}

.page_devs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.1rem solid #d8d8d8;
  margin-bottom: 3.25rem;
}

.page_red {
  padding-right: 5rem;
}

.advantage-button {
  width: 1.875rem;
  height: 1.875rem;
  background: #000;
  border: none;
  border-radius: 50%;
}

.page_ico2 {
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
}

.page_title {
  color: #222;
  font-size: 2.25rem;
  line-height: 3.125rem;
}

.page_advantage_d {
  /* display: flex; */
}

.page_set_de_e {
  /* width: 60%; */
  /* margin-left: 2.875rem; */
}

.image_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page_advantage_img {
  width: 37.81rem;
  height: 36.25rem;
  object-fit: cover;
  /* z-index: 100; */
}

.page_set_text {
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: #222222;
}

.page_set_text2 {
  padding: 1.75rem 0;
}

/*  */
</style>